enum ObjectState {
  HIDDEN = 0,
  LOADING,
  SHOWN,
  ERROR
}

export default ObjectState
